import { useGetListBankAccount } from "../../api/bankAccount";

export const useBankAccountManagement = (
  companyId: number,
  params: { start: number; end: number },
  name?: string,
  currencyId?: number,
  ignoreId?: string
) => {
  const {
    data = {
      data: {
        data: { total: 0, pageSize: 10, page: 1, totalPages: 1, items: [] },
      },
    },
    isLoading,
    refetch,
  } = useGetListBankAccount({
    companyId,
    ...params,
    name,
    currencyId,
    ignoreId,
  });
  return { dataListBankAccount: data.data.data, isLoading, refetch };
};
